import { CHANNELS } from '@/models/dashboards/channels.enum';

export const MEDIA_TYPE_BREAKDOWN = Object.freeze({
  AD: { label: 'Ad', icon: 'ad' },
  ALL_MEDIA: { label: 'All Media', icon: 'all' },
  CAROUSEL: { label: 'Carousel', icon: 'carousel' },
  CAROUSEL_CONTAINER: { label: 'Carousel Container', icon: 'carousel' },
  DOCUMENT: { label: 'Document', icon: 'text' },
  IGTV: { label: 'IGTV', icon: 'tv' },
  IMAGE: { label: 'Image', icon: 'photo' },
  IMAGE_CAROUSEL: { label: 'Images + Carousels', icon: 'mixed' },
  LINK: { label: 'Link', icon: 'link' },
  LIVE: { label: 'Live', icon: 'live' },
  MULTI_IMAGE: { label: 'Multi Image', icon: 'mixed' },
  ON_DEMAND: { label: 'On Demand', icon: 'video' },
  PHOTO: { label: 'Photos', icon: 'photo' },
  PHOTO_CAROUSEL: { label: 'Photos + Carousels', icon: 'mixed' },
  POST: { label: 'Posts', icon: 'photo' },
  REEL: { label: 'Reels', icon: 'reel' },
  SHORT: { label: 'Shorts', icon: 'reel' },
  STORY: { label: 'Stories', icon: 'story' },
  TEXT: { label: 'Text', icon: 'text' },
  VIDEO: { label: 'Videos', icon: 'video' },
  VIDEO_REEL: { label: 'Videos + Reels', icon: 'mixed' },
});

export const CHANNEL_TO_BASE: Record<string, string> = {
  [CHANNELS.INSTAGRAM_COMPETITIVE.value]: CHANNELS.INSTAGRAM.value,
  [CHANNELS.INSTAGRAM_UGC.value]: CHANNELS.INSTAGRAM.value,
  [CHANNELS.INSTAGRAM_STORIES_UGC.value]: CHANNELS.INSTAGRAM.value,
  [CHANNELS.FACEBOOK_COMPETITIVE.value]: CHANNELS.FACEBOOK.value,
  [CHANNELS.TIKTOK_UGC.value]: CHANNELS.TIKTOK.value,
  [CHANNELS.TWITTER_COMPETITIVE.value]: CHANNELS.TWITTER.value,
  [CHANNELS.YOUTUBE_COMPETITIVE.value]: CHANNELS.YOUTUBE.value,
};

export const VALID_MEDIA_TYPES_BY_CHANNEL: Record<string, string[]> = {
  [CHANNELS.FACEBOOK.value]: ['ALL_MEDIA', 'CAROUSEL', 'LINK', 'PHOTO', 'REEL', 'TEXT', 'VIDEO'],
  [CHANNELS.INSTAGRAM.value]: [
    'ALL_MEDIA',
    'CAROUSEL',
    'PHOTO',
    'PHOTO:CAROUSEL',
    'REEL',
    'VIDEO',
    'VIDEO:REEL',
  ],
  [CHANNELS.LINKEDIN.value]: [
    'ALL_MEDIA',
    'DOCUMENT',
    'LINK',
    'MULTI_IMAGE',
    'PHOTO',
    'TEXT',
    'VIDEO',
  ],
  [CHANNELS.PINTEREST.value]: ['ALL_MEDIA', 'CAROUSEL', 'PHOTO', 'VIDEO'],
  [CHANNELS.TIKTOK.value]: ['ALL_MEDIA', 'PHOTO', 'VIDEO'],
  [CHANNELS.TWITTER.value]: ['ALL_MEDIA', 'CAROUSEL', 'LINK', 'PHOTO', 'TEXT', 'VIDEO'],
  [CHANNELS.YOUTUBE.value]: ['ALL_MEDIA', 'LIVE', 'ON_DEMAND', 'SHORT'],
};

export const VALID_DB_MEDIA_TYPES: Record<string, string[]> = {
  [CHANNELS.INSTAGRAM.value]: [
    'ALL_MEDIA',
    'AD',
    'CAROUSEL_CONTAINER',
    'IGTV',
    'LIVE',
    'POST',
    'STORY',
    'REEL',
  ],
};

const ALL_CHANNEL_VALUES = [
  CHANNELS.FACEBOOK.value,
  CHANNELS.INSTAGRAM.value,
  CHANNELS.LINKEDIN.value,
  CHANNELS.PINTEREST.value,
  CHANNELS.TIKTOK.value,
  CHANNELS.TWITTER.value,
  CHANNELS.YOUTUBE.value,
];

export const CANONICAL_MEDIA_TYPE_CHANNELS: Record<string, Record<string, string[]>> = {
  ES: {
    ALL_MEDIA: ALL_CHANNEL_VALUES,
    CAROUSEL: [
      CHANNELS.FACEBOOK.value,
      CHANNELS.INSTAGRAM.value,
      CHANNELS.PINTEREST.value,
      CHANNELS.TWITTER.value,
    ],
    DOCUMENT: [CHANNELS.LINKEDIN.value],
    'PHOTO:CAROUSEL': [CHANNELS.INSTAGRAM.value],
    LINK: [CHANNELS.FACEBOOK.value, CHANNELS.LINKEDIN.value, CHANNELS.TWITTER.value],
    LIVE: [CHANNELS.YOUTUBE.value],
    MULTI_IMAGE: [CHANNELS.LINKEDIN.value],
    ON_DEMAND: [CHANNELS.YOUTUBE.value],
    PHOTO: [
      CHANNELS.FACEBOOK.value,
      CHANNELS.INSTAGRAM.value,
      CHANNELS.LINKEDIN.value,
      CHANNELS.PINTEREST.value,
      CHANNELS.TIKTOK.value,
      CHANNELS.TWITTER.value,
    ],
    REEL: [CHANNELS.FACEBOOK.value, CHANNELS.INSTAGRAM.value],
    SHORT: [CHANNELS.YOUTUBE.value],
    TEXT: [CHANNELS.FACEBOOK.value, CHANNELS.LINKEDIN.value, CHANNELS.TWITTER.value],
    VIDEO: [
      CHANNELS.FACEBOOK.value,
      CHANNELS.INSTAGRAM.value,
      CHANNELS.LINKEDIN.value,
      CHANNELS.PINTEREST.value,
      CHANNELS.TIKTOK.value,
      CHANNELS.TWITTER.value,
    ],
    'VIDEO:REEL': [CHANNELS.INSTAGRAM.value],
  },
  DB: {
    AD: [CHANNELS.INSTAGRAM.value],
    ALL_MEDIA: ALL_CHANNEL_VALUES,
    CAROUSEL_CONTAINER: [CHANNELS.INSTAGRAM.value],
    IGTV: [CHANNELS.INSTAGRAM.value],
    LIVE: [CHANNELS.INSTAGRAM.value],
    POST: [CHANNELS.INSTAGRAM.value],
    REEL: [CHANNELS.INSTAGRAM.value],
    STORY: [CHANNELS.INSTAGRAM.value],
  },
};
